import React, { useEffect } from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormIntlNumberInput,
    ReactHookFormToggleButtonGroup,
} from 'common/components/form/bootstrap';

const PanelsOrKwInput = ({ control, offerPanels, setValue }) => {
    const { t } = useTranslation();

    const [
        fill_algorithm,
        is_custom_module,
        kW,
        panel,
        solar_module,
        solar_modules_number,
    ] = useWatch({
        control,
        name: [
            'fill_algorithm',
            'is_custom_module',
            'kW',
            'panel',
            'solar_module',
            'solar_modules_number',
        ],
    });

    const selectedModule = is_custom_module
        ? panel
        : offerPanels.find((item) => item.id === solar_module);

    const changeSolarModulesNumberValue = (value, watts, setValue) => {
        const parsedValue = parseFloat(value);
        const parsedWatts = parseFloat(watts);
        let units = 0;
        if (parsedValue > 0 && parsedWatts > 0)
            units = (parsedValue * 1000) / parsedWatts;
        setValue('solar_modules_number', Math.ceil(units));
    };

    const changeKwValue = (value, watts, setValue) => {
        const parsedValue = parseFloat(value);
        const parsedWatts = parseFloat(watts);
        let kW = 0;
        if (parsedValue > 0 && parsedWatts > 0)
            kW = (parsedValue * parsedWatts) / 1000;
        setValue('kW', kW);
    };

    useEffect(() => {
        if (fill_algorithm === 'kW') {
            changeSolarModulesNumberValue(kW, selectedModule?.watts, setValue);
        }
    }, [panel?.watts]);

    return (
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
            <ReactHookFormToggleButtonGroup
                control={control}
                fullWidth
                name="fill_algorithm"
                onChange={(value) => {
                    if (value === 'u') {
                        changeSolarModulesNumberValue(
                            kW,
                            selectedModule?.watts,
                            setValue,
                        );
                    } else if (value === 'kW') {
                        changeKwValue(
                            solar_modules_number,
                            selectedModule?.watts,
                            setValue,
                        );
                    }
                }}
                options={[
                    { label: 'Fill', value: 'fill' },
                    { label: 'u', value: 'u' },
                    { label: 'kW', value: 'kW' },
                ]}
            />

            {fill_algorithm === 'u' && (
                <ReactHookFormIntlNumberInput
                    control={control}
                    fullWidth
                    label={t('Panel', { count: 2 })}
                    name="solar_modules_number"
                    onChange={({ target }) => {
                        changeKwValue(
                            target.value,
                            selectedModule?.watts,
                            setValue,
                        );
                    }}
                />
            )}

            {fill_algorithm === 'kW' && (
                <ReactHookFormIntlNumberInput
                    control={control}
                    fullWidth
                    label="kW"
                    name="kW"
                    onChange={({ target }) => {
                        changeSolarModulesNumberValue(
                            target.value,
                            selectedModule?.watts,
                            setValue,
                        );
                    }}
                />
            )}
        </Box>
    );
};

PanelsOrKwInput.propTypes = {
    control: PropTypes.object,
    offerPanels: PropTypes.array,
    setValue: PropTypes.func,
};

export default PanelsOrKwInput;
